var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTriangleRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.788 6.674a1 1 0 010 1.652l-8.225 5.608A1 1 0 010 13.108V1.892a1 1 0 011.563-.826z",
    fill: "currentColor"
  })));
}

export default __webpack_public_path__ + "triangle-right-4d86767c770b0e3fb6e407cf975044b5.svg";
export { SvgTriangleRight as ReactComponent };